import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  maxWidthWrapper: {
    zIndex: 100,
    marginBottom: -1,
    paddingBottom: theme.spacing[3],
    backgroundColor: colors.backgroundPrimary,
  },
  header: {
    flex: 1,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: colors.backgroundPrimary,
    paddingTop: rt.insets.top + theme.spacing[6],
    paddingHorizontal: theme.spacing[5],
    elevation: 0,
    borderBottomWidth: 0,
    shadowColor: 'transparent',
  },
  headerButton: {
    padding: theme.spacing[2],
    backgroundColor: colors.backgroundL1,
    borderRadius: theme.borderRadius.full,
    _web: {
      cursor: 'pointer',
      outlineStyle: 'none',
      ':focus': {
        outlineStyle: 'solid',
        outlineWidth: 2,
        outlineColor: colors.borderSelected,
        outlineOffset: 2,
        backgroundColor: colors.backgroundHover,
      },
      ':hover': {
        backgroundColor: colors.backgroundHover,
      },
    },
  },
}));
